module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE4IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDdIMy40MzZsNS4zMy01LjI4OUExIDEgMCAxIDAgNy4zNTkuMjg5bC03LjA2MiA3YTEgMSAwIDAgMC0uMDA5IDEuNDE0bDcgNy4wNjJhMSAxIDAgMSAwIDEuNDI0LTEuNDA1TDMuMzk0IDlIMTdhMSAxIDAgMSAwIDAtMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left-arrow.svg
// module id = N2cq
// module chunks = 6 16 143